import { Row } from 'react-styled-flexboxgrid';
import styled from 'styled-components';

import { media } from '@savgroup-front-common/constants';
import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';

export const $ActionRow = styled(Row)<{
  $withoutMarginBottom?: boolean;
  $withoutPadding?: boolean;
}>`
  display: flex;
  justify-content: flex-end;
  padding: ${({ $withoutPadding }) =>
    $withoutPadding ? null : `0 ${spacing('lg')}`};
  margin-left: unset;
  margin-right: unset;

  > * {
    margin-left: ${spacing('sm')};
    margin-bottom: ${({ $withoutMarginBottom }) =>
      $withoutMarginBottom ? null : spacing(3.5)};
    flex-grow: initial;
  }

  @media ${media.maxWidth.sm} {
    margin-top: ${spacing('lg')};

    flex-direction: column-reverse;
    gap: ${spacing('lg')};

    > * {
      margin-left: 0;
      margin-bottom: 0;
      flex-grow: initial;
    }
  }
`;

export const $NakedActionRow = styled.div`
  display: flex;
  justify-content: end;
  align-items: center;
  width: 100%;
  gap: ${spacing('sm')};
`;
